import React from "react";
import "./project.css";

// import { motion } from "framer-motion";

// import { fadeIn } from "../../variants";


import proj1 from "../../assets/proj1.png"
import proj2 from "../../assets/proj2.png"
import proj3 from "../../assets/proj3.png"
import proj4 from "../../assets/proj4.1.png"


const Project = () => {
  return (
    <section id="project" className="">
      <h5>What have I done?</h5>
      <h2>My Projects</h2>

      <div className="container flex justify-center items-center">
        <div className="flex flex-col lg:flex-row gap-x-24">
          <div className="flex-1 flex flex-col gap-y-12">
            {/* {image} */}
              <div className="group relative overflow-hidden border-2 border-white rounded-xl w-96">
                <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>

                <img
                  className="group-hover:scale-125 transition-all duration-500"
                  src={proj1}
                  alt=""
                />

                <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                  <span className="text-blue-400">Mobile Application with React Native</span>
                </div>
                <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-500 z-50">
                  <span className="text-3xl text-white">Schedule Builder</span>
                </div>

                <div className="absolute -bottom-full left-12 group-hover:bottom-9 transition-all duration-500 z-50">
                  <span className="text-sm text-slate-50">(On Progress)</span>
                </div>
              </div>
            
            {/* {image} */}
            <a
              href="https://github.com/henrytran58/english-vocabulary"
              target="_blank"
              rel="noreferrer"
            >
              <div className="group relative overflow-hidden border-2 border-white rounded-xl w-96">
                <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                <img
                  className="group-hover:scale-125 transition-all duration-500"
                  src={proj2}
                  alt=""
                />
                <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                  <span className="text-blue-400">Desktop Application with Python</span>
                </div>
                <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-500 z-50">
                  <span className="text-3xl text-white">English Vocabulary</span>
                </div>
              </div>
            </a>
          </div>
          <div className="flex-1 flex flex-col gap-y-12 mt-12">
            <a
              href="https://github.com/henrytran58/slide-puzzle-game-android"
              target="_blank"
              rel="noreferrer"
            >
              {/* {image} */}
              <div className="group relative overflow-hidden border-2 border-white rounded-xl w-96">
                <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                <img
                  className="group-hover:scale-125 transition-all duration-500"
                  src={proj3}
                  alt=""
                />
                <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                  <span className="text-blue-400">Android Application with Java</span>
                </div>
                <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-500 z-50">
                  <span className="text-3xl text-white">Sliding Puzzle</span>
                </div>
              </div>{" "}
            </a>

            {/* {image} */}
            <a
              href="https://github.com/lamula21/AppTracker"
              target="_blank"
              rel="noreferrer"
            >
              <div className="group relative overflow-hidden border-2 border-white rounded-xl w-96">
                <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
                <img
                  className="group-hover:scale-125 transition-all duration-500"
                  src={proj4}
                  alt=""
                />
                <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                  <span className="text-blue-400">Web Application with MERN</span>
                </div>
                <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-500 z-50">
                  <span className="text-3xl text-white">AppTracker</span>
                </div>
                <div className="absolute -bottom-full left-12 group-hover:bottom-9 transition-all duration-500 z-50">
                  <span className="text-sm text-slate-50">(Group Project)</span>
                </div>
              </div>{" "}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Project;
